// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Erhe","selected":"styles_selected__Auclc"};